import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"
import { normalizeError } from "../../utils/errorHelpers"

export const getOwnEmailSettings = createAsyncThunk('emailSettings/getOwn', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/users/me/email-settings')
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const saveOwnEmailSettings = createAsyncThunk('emailSettings/saveOwn', async ({ muteAll, mutedGroups }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put('/users/me/email-settings', { muteAll, mutedGroups })
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const getUserEmailSettings = createAsyncThunk('emailSettings/getUser', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/users/${encodeURIComponent(userId)}/email-settings`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const saveUserEmailSettings = createAsyncThunk('emailSettings/saveUser', async ({ userId, muteAll, mutedGroups }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/users/${encodeURIComponent(userId)}/email-settings`, { muteAll, mutedGroups })
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const getOfficeEmailMute = createAsyncThunk('emailSettings/getOfficeMute', async (groupId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/contact-groups/${encodeURIComponent(groupId)}/notification-email-mute`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})
